import type { AccessResource } from '../../../../main/types/accessControlTypes';
import { CHANNEL_LEVEL_SETTINGS, WRITE_PERMISSION } from '../../../support/accessControlConstants';

export const ACCESS_COMPONENT_DEFAULT_PROPS: { accessResources: AccessResource[]; permission: number } = {
  accessResources: [CHANNEL_LEVEL_SETTINGS],
  permission: WRITE_PERMISSION,
};
